import React from "react";
import { Switch } from "react-router-dom";
import Feed from "../components/pages/Feed";
import Charts from "../components/pages/Charts";
import Featured from "../components/pages/Featured";
import Discover from "../components/pages/Discover";
import Playlists from "../components/pages/Playlists";
import Profile from "../components/profile/Profile";
import Dashboard from "../components/dashboard/Dashboard";
import Account from "../components/account/Account";
// import ScrollToTop from "react-router-scroll-top"
import AppRoute from "./AppRoute";
import Welcome from "../components/layout/Welcome";
import Login from "../components/auth/Login";
import Register from "../components/auth/Register";
import MainApp from "../components/layout/MainApp";
import PageNotFound from "../components/layout/PageNotFound";
import Landing from "../components/landing/Landing";
import Playlist from "../components/pages/playlist/Playlist";
import Pricing from "../components/landing/Pricing";
import CreateTrack from "../components/create/CreateTrack";
import Search from "../components/pages/Search";
import Comments from "../components/pages/track/Comments";
import { AnimatePresence } from "framer-motion";

const Routes = () => {
  // const location = useLocation();
  return (
    <AnimatePresence exitBeforeEnter>
      <Switch>
        {/* <ScrollToTop /> */}
        <AppRoute path="/login" component={Login} layout={Welcome} exact />
        <AppRoute
          path="/register"
          component={Register}
          layout={Welcome}
          exact
        />
        <AppRoute path="/" exact component={Landing} layout={Welcome} />
        <AppRoute path="/pricing" exact component={Pricing} layout={Welcome} />
        <AppRoute path="/feed" exact component={Feed} layout={MainApp} />
        <AppRoute path="/charts" exact component={Charts} layout={MainApp} />
        <AppRoute
          path="/featured"
          exact
          component={Featured}
          layout={MainApp}
        />
        <AppRoute
          path="/discover"
          exact
          component={Discover}
          layout={MainApp}
        />
        <AppRoute
          path="/playlist"
          exact
          component={Playlists}
          layout={MainApp}
        />
        <AppRoute path="/search" exact component={Search} layout={MainApp} />
        <AppRoute
          path="/comments/:tid"
          exact
          component={Comments}
          layout={MainApp}
        />

        <AppRoute
          path="/create-track"
          exact
          component={CreateTrack}
          layout={MainApp}
        />
        <AppRoute path="/pl/:id" exact component={Playlist} layout={MainApp} />
        <AppRoute path="/profile" exact component={Profile} layout={MainApp} />
        <AppRoute
          path="/usr/:username"
          exact
          component={Profile}
          layout={MainApp}
        />
        <AppRoute
          path="/dashboard"
          exact
          component={Dashboard}
          authenticate={true}
          layout={MainApp}
        />
        <AppRoute
          path="/account"
          exact
          component={Account}
          authenticate={true}
          layout={MainApp}
        />
        <AppRoute path="*" exact component={PageNotFound} layout={MainApp} />
      </Switch>
    </AnimatePresence>
  );
};

export default Routes;
